import { createAsyncThunk } from '@reduxjs/toolkit';
import Api, { FetchParams } from '../../utils/Api';

type ChargeRedcatPaySavedCardDto = {
  readonly cardToken: string;
  readonly amount: number;
  readonly storeId?: string;
  readonly receiptEmail?: string;
  readonly loyalty?: Record<string, unknown>;
  readonly recaptchaToken?: string | null;
  readonly channel: 'web' | 'ios' | 'android';
  readonly idempotencyKey?: string | null;
};

type ChargeRedcatPaySavedCardResponse = {
  readonly receipt_id: string;
  readonly idempotency_key?: string;
  readonly status?: string;
};

export const chargeRedcatPaySavedCard = createAsyncThunk(
  '$chargeRedcatPaySavedCard',
  async (data: ChargeRedcatPaySavedCardDto, { rejectWithValue }) => {
    const {
      cardToken,
      amount,
      storeId,
      receiptEmail,
      loyalty,
      recaptchaToken,
      channel,
      idempotencyKey,
    } = data;

    try {
      const params: FetchParams = {
        method: 'POST',
        path: `/api/v2/online-payments/cards/${cardToken}/charge`,
        headers: {
          ...(idempotencyKey && { 'X-REDCAT-IDEMPOTENCY-KEY': idempotencyKey }),
        },
        body: {
          amount,
          hideCVC: true,
          channel,
          ...(storeId && { store_id: parseInt(storeId) }),
          ...(receiptEmail && { receipt_email: receiptEmail }),
          ...(loyalty && { loyalty }),
          ...(recaptchaToken && { 'g-recaptcha-response': recaptchaToken }),
        },
      };

      const response = await Api.fetch(params, 'member');

      return response.data as ChargeRedcatPaySavedCardResponse;
    } catch (e) {
      return rejectWithValue(e);
    }
  },
);
